module.exports = __webpack_public_path__ + "img/HZGB06-30W.fd2c40c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB06-30W.png
// module id = iK8h
// module chunks = 0